import {handleValidationChange} from '../CommonValidation';

export const validateExpenses = (data, setIsError) => {
    var isValid = true;

    if(data.invoice_no === "" || data.invoice_no === undefined) {
        handleValidationChange("invoice_no", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("invoice_no", false, setIsError);
    }

    if(data.expense_date === "" || data.expense_date === undefined) {
        handleValidationChange("expense_date", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("expense_date", false, setIsError);
    }

    if(data.branch_id === "" || data.branch_id === undefined) {
        handleValidationChange("branch_id", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("branch_id", false, setIsError);
    }

    if(data.supplier_name === "" || data.supplier_name === undefined) {
        handleValidationChange("supplier_name", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("supplier_name", false, setIsError);
    }

    if(data.encoded_by === "" || data.encoded_by === undefined) {
        handleValidationChange("encoded_by", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("encoded_by", false, setIsError);
    }

    return isValid
  
}

// to check if sales items required filleds have data
export const validateExpenseItems = (items) => {
        const errors = {};
        // const finalItems = []
        items.map((item, itemIndex) => {
            if (item.name === '' || item.name === null || item.name === undefined) {
                errors[itemIndex] = {
                ...errors[itemIndex],
                name: 'Item is required',
                };
            }

            if (item.qty === '' || item.qty === null || item.qty === undefined) {
                errors[itemIndex] = {
                ...errors[itemIndex],
                qty: 'Qty is required',
                };
            }

            if (item.unit === '' || item.unit === null || item.unit === undefined) {
                errors[itemIndex] = {
                ...errors[itemIndex],
                unit: 'Unit is required',
                };
            }

            if (item.price === '' || item.price === null || item.price === undefined) {
                errors[itemIndex] = {
                ...errors[itemIndex],
                price: 'Price is required',
                };
            }
        });

        return errors;

}
